






import NewDeployment from "@/components/NewDeployment.vue";

export default {
    name: "Services",
    components: {
        NewDeployment
    }
};
